import { render, staticRenderFns } from "./TypePage.vue?vue&type=template&id=05b620b1&"
import script from "./TypePage.vue?vue&type=script&lang=js&"
export * from "./TypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports